import PinnedPosts from './PinnedPosts'

export default PinnedPosts
